module.exports = __webpack_public_path__ + "img/foodplan.f95feed4.svg";